import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';

/**
 * Returns if the meeting is on public calendar.
 * If item represents an appointment, then it returns false.
 * @param event calendar event object
 */
export default function isMeetingOnPublicCalendar(event: CalendarEvent): boolean {
    return isEventAMeeting(event) && isOnPublicCalendarFolder(event);
}

/**
 * Gets whether the current item is on a public calendar folder
 * @param event calendar event object
 */
function isOnPublicCalendarFolder(event: CalendarEvent): boolean {
    let calendarEntry = getCalendarEntryByFolderId(event.ParentFolderId.Id);

    return (
        calendarEntry &&
        calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.PublicCalendarFolder
    );
}
